export default "__VITE_ASSET__D95TEWEp__"